import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../core/configuration/properties-settings';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { FondoOnereAdapter } from '../../components/fascicolo/sezione-economica-fondo-oneri-update/fondo-onere-adapter';
import { SezioneEconomicaResponse } from '../../models/dto/sezione-economica-response';
import { SezioneLegaliResponse } from '../../models/dto/sezione-legali-response';
import { FondoOnere } from '../../models/fondo-onere';
import { LegaleIncaricato } from '../../models/legale-incaricato';
import { Mese } from '../../models/mock/mese';
import { mesiOptions } from '../../models/mock/mock-mesi';
import { SezioneEconomica } from '../../models/sezioni/sezione-economica';
import { SezioneLegali } from '../../models/sezioni/sezione-legali';
import { TipoFase } from '../../models/tipologiche/tipo-fase';
import { FormValidationService } from '../../services/form-validation.service';
import { BaseForm } from '../base-Form';

@Component({
    selector: 'div [sezione-economica-fondo-oneri-form]',
  templateUrl: 'sezione-economica-fondo-oneri-form.component.html'
})

export abstract class SezioneEconomicaFondoOneriFormComponent extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  sezione: SezioneEconomica;
  request: FondoOnere;
  fondoOneriForm: FormGroup;

  // options
  meseOptions: Mese[] = [];
  legaliAll: LegaleIncaricato[] = [];
  legaliOptions: LegaleIncaricato[] = [];
  tipoFaseOptions: TipoFase[] = [];
  meseAdapter: Mese = new Mese();

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  // private idTipoPersonaFisica: string = PropertiesSettings.ID_TIPO_PERSONA_FISICA;
  abstract getFondoOnere(): FondoOnere;
  abstract getRequest(request: FondoOnere);
  abstract getUrlReadSezioneEconomica(): string;
  abstract getUrlReadSezioneLegali(): string;

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
                super();
  }

  initRequest() {
    this.meseAdapter = new Mese();
    this.request = new FondoOnereAdapter(this.getFondoOnere()).fondoOnere;
    if (this.request.mese) {
      this.meseAdapter.id = this.request.mese;
    }else {
      this.meseAdapter.id = -1;
    }
    this.populateSelect();
    this.initViewToggle();
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.initRequest();
    this.fondoOneriForm = this.campiForm.group({
      id: [this.request.id],
      legaleIncaricato: [this.request.legaleIncaricato],
      tipoFase: [this.request.tipoFase, Validators.required],
      anno: [this.request.anno, Validators.compose([this.formValidationService.anno])],
      mese: [this.request.mese],
      importo: [this.request.importo, Validators.required],
      nota: [this.request.nota]
    });
    this.annoMeseDefault();
  }

  annoMeseDefault(){
    this.request.anno = new Date().getFullYear();
    this.request.mese = new Date().getMonth();
    this.meseAdapter = mesiOptions.find(el=>el.id===(this.request.mese+1));
  }

  populateSelect() {
    if (this.tipoFaseOptions.length === 0) {
      this.helpers.getTipiFase().subscribe(response => this.tipoFaseOptions = response);
    }
    if (this.meseOptions.length === 0) {
      this.meseOptions = mesiOptions;
    }
  }

  save() {
    this.request.mese = this.meseAdapter.id;
    let requestCopy: FondoOnere = new FondoOnereAdapter(this.request).fondoOnere;
    if (requestCopy.importo) {
      requestCopy.importo = requestCopy.importo.toString().replace(',', '.');
    }
    this.getRequest(requestCopy);
  }

  readSezioneEconomicaResponse(sezioneEconomica: SezioneEconomica) {
    this.sezione = sezioneEconomica;
  }

  readSezioneEconomica(idSezioneDatiEconomici: string) {
    if (idSezioneDatiEconomici) {
      this.operationService.readSezione(this.getUrlReadSezioneEconomica(), idSezioneDatiEconomici)
        .subscribe(response => this.readSezioneEconomicaResponse((<SezioneEconomicaResponse>response).sezione));
    }
  }

  readSezioneLegali(idSezioneLegali: string) {
    if (idSezioneLegali) {
      this.operationService.readSezione(this.getUrlReadSezioneLegali(), idSezioneLegali)
        .subscribe(response => this.readSezioneLegaliResponse((<SezioneLegaliResponse>response).sezione));
    }
  }

  readSezioneLegaliResponse(sezioneLegali: SezioneLegali) {
    this.legaliAll = sezioneLegali.legaliIncaricati;
    this.legaliAll = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.revocato === false; });

    if (this.getFondoOnere() && !this.inserimento) {
      this.legaliOptions = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.categoriaLegaleIncaricato.id === this.getFondoOnere().legaleIncaricato.categoriaLegaleIncaricato.id; });
    }
  }

  populateBeneficiari(event: any) {
    if (event.target.value && this.legaliAll.length > 0) {
      this.legaliOptions = this.legaliAll.filter(legale => { return legale.categoriaLegaleIncaricato.id === event.target.value; });
    }
  }

  goToAssocia() {
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  associaLegale(legaleIncaricato: LegaleIncaricato) {
    this.getLegale(legaleIncaricato);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  getLegale(obj: any) {
    if (obj.id) {
      this.request.legaleIncaricato =  this.legaliAll.filter(legale => { return legale.id === obj.id; })[0];
    }
  }

  private getBeneficiarioLabel(legaleIncaricato: LegaleIncaricato): string {
    let result = '';
    if (legaleIncaricato && legaleIncaricato.legale && legaleIncaricato.legale.tipoPersona) {
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = legaleIncaricato.legale.cognome + ' ' + legaleIncaricato.legale.nome;
      }
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = legaleIncaricato.legale.ragioneSociale;
      }
    }
    return result;
  }
}
